/**
 * L19 — frontend mirror of the backend MonthlyReport model.
 */

export const MONTHLY_REPORT_STATUSES = [
  'GENERATING',
  'READY',
  'SENT',
  'FAILED',
] as const;
export type MonthlyReportStatus =
  (typeof MONTHLY_REPORT_STATUSES)[number];

export interface MonthlyReport {
  id: string;
  vesselId: string;
  periodYear: number;
  periodMonth: number;
  generatedAt: string;
  pdfKey: string | null;
  sentAt: string | null;
  sentToEmails: string[];
  status: MonthlyReportStatus;
  errorMessage: string | null;
}

export interface AdminMonthlyReportRow extends MonthlyReport {
  vessel: { name: string };
}

export interface PresignedPdfUrl {
  url: string;
  expiresAt: string;
}

export function statusBadgeClass(status: MonthlyReportStatus): string {
  switch (status) {
    case 'GENERATING':
      return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'READY':
      return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'SENT':
      return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'FAILED':
      return 'bg-red-50 text-red-700 border-red-200';
  }
}

/** "2026-04" — used as a stable key + display label. */
export function formatPeriod(report: { periodYear: number; periodMonth: number }): string {
  return `${report.periodYear}-${String(report.periodMonth).padStart(2, '0')}`;
}
